import React from "react";
import Card from "react-bootstrap/Card";


function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
              <blockquote className="blockquote mb-0">
  <p style={{ textAlign: "justify" }}>
    Hi Everyone, My Self <span className="purple">Uma Ajay Kumar Reddy P S</span>.
    I am a focused and enthusiastic developer with a keen interest in web development and software development. By comprehensive exposure to the underlying concepts and applying them vividly to various projects, my love for these domains came into being. I am a passionate individual who thrives to build and apply algorithms to solve real-world industry problems.
    <br />
    <br />
    I have recently started a start-up called "Sanjeev Foundation," which is an online classroom program with an aim to transform the future of learning. This website provides integration of courses where one can find all courses under one roof. Currently, we have 57 students who have joined our company for learning coding, and we have completed nearly 4 projects in 2020. In addition to this, I have also started another start-up called "Sanjeev Solutions" in 2021, where I design web applications for business and commercial purposes and also work as a freelancer for some online projects.
    <br />
    <br />
    I am thrilled to announce that I have been selected by HCL from M S Ramaiah University of Applied Sciences and have received a job offer of INR 6,00,000. While my current role is in embedded C development.
    <br />
    <br />
    I am highly motivated to transition into a full stack developer role and am open to exploring opportunities with other companies that can offer me this career path. I am well-versed in both front-end and back-end technologies, including the MERN stack (MongoDB, ExpressJS, ReactJS, and NodeJS).
    <br />
    <br />
    SANJEEV FOUNDATION (E-Learning and Software Solutions) (Uma Ajay)
    <br />
    Bellary, India CEO Founder
    <br />
    Sanjeev Foundation is an online classroom program with an aim to transform the future of learning. This website provides integration of courses where one can find all courses under one roof. This website is designed using technologies such as HTML, CSS, JS, JQUERY, and Bootstrap.
    <br />
    <br />
    LINK: <a href="https://www.sanjeevfoundation.me">SanjeevFoundation</a>
  </p>
</blockquote>

      </Card.Body>
    </Card>
  );
}

export default AboutCard;